module.exports = __webpack_public_path__ + "img/inclinacion.06b2bd53.gif";